/** содержит все файлы манифестов пакетов из binary  */
export const alfaBankManifests = require.context(
    '@alfa-bank',
    true,
    /\.\/[\da-z-]+\/widgets\.manifest\.ts$/
);
